import { usePermissions } from "contexts/permission";

export default function useCheckPermission(config) {
  const permissions = usePermissions();

  // Handle string-based conditions
  if (typeof config === "string") {
    const canRead = permissions.evaluatePermission(config);
    return {
      canRead,
      canUpdate: canRead,
      canDelete: canRead,
      canCreate: canRead,
      canMutate: canRead,
    };
  }

  // Destructure config object
  const {
    collection,
    field = "*",
    action = "read",
    access,
    type,
    operator,
    conditions,
  } = config || {};

  const getCondition = (act) =>
    type === "multiple"
      ? {
          type: "multiple",
          collection,
          action: act,
          access,
          operator,
          conditions,
        }
      : field === "*"
        ? { type: "collection", collection, action: act, access }
        : { type: "key", collection, key: field, action: act, access };

  const cando = permissions.evaluatePermission(getCondition(action));
  const canUpdate = permissions.evaluatePermission(getCondition("update"));
  const canDelete = permissions.evaluatePermission(getCondition("delete"));
  const canCreate = permissions.evaluatePermission(getCondition("create"));
  const canRead = permissions.evaluatePermission(getCondition("read"));

  return {
    canUpdate,
    canDelete,
    canCreate,
    canRead,
    canMutate: cando, // legacy alias
  };
}
